import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useUiStore } from './stores/ui'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// The theme must settle before the router mounts the first screen.
useUiStore(pinia).initTheme()

app.use(router)
app.mount('#app')
